import React from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import './Layout.css'; // Assuming you have a CSS file for layout styles
const Layout = ({ children }) => {
  return (
    <div className="app-container">
      <Navbar />
      <main className="main-content">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
